import { useEffect, useState } from 'react';

import { completionsApi } from '../api';
import type { CourseCompletionResponse } from '../types';

export function useProfileCourses(authenticatedUser) {
  const [userCoursesCompletions, setUserCoursesCompletions] = useState<CourseCompletionResponse[]>([]);
  const [isUserCoursesCompletionsLoaded, setIsUserCoursesCompletionsLoaded] = useState<boolean>(false);

  const getCourseCompletions = (id: string) => (
    userCoursesCompletions.find((course: CourseCompletionResponse) => course?.course_key === id)?.completion
  );

  const getCourseGrade = (id: string) => (
    userCoursesCompletions.find((course: CourseCompletionResponse) => course?.course_key === id)?.grade ?? null
  );

  useEffect(() => {
    if (authenticatedUser) {
      completionsApi.getUserAllCourseCompletions(
        authenticatedUser.username,
        (res: CourseCompletionResponse[]) => {
          setUserCoursesCompletions(res);
          setIsUserCoursesCompletionsLoaded(true);
        },
      );
    } else {
      setIsUserCoursesCompletionsLoaded(true);
    }
  }, []);

  return {
    userCoursesCompletions,
    getCourseCompletions,
    getCourseGrade,
    isUserCoursesCompletionsLoaded,
  };
}
